/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function ActionCell({ id, filtered, row, traderView, handleApplyAction }) {
  return (
    <SoftBox display="flex" alignItems="center">
      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            display: traderView ? "" : "none",
            backgroundColor: "#e9e9e9",
            borderRadius: "20px",
          }}
        >
          <Tooltip title={"Open Trader View"} placement="top">
            <Icon
              onClick={(e) => handleApplyAction(e, id, row, filtered, "trader")}
              className="play-action"
            >
              compare_arrows_icon
            </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          sx={{
            cursor: row.original.blocked ? "not-allowed" : "pointer",
            lineHeight: 0,
            display: filtered ? "" : "none",
            color: "green",
            opacity: 0.5,
          }}
        >
          <Tooltip
            title={row.original.blocked ? "Blocked Fixture " : "Start Feed Fixture"}
            placement="top"
          >
            <Icon
              isdisabled={row.original.blocked ? "true" : "false"}
              onClick={
                row.original.blocked
                  ? null
                  : (e) => handleApplyAction(e, id, row, filtered, "regular")
              }
              className={row.original.blocked ? "play-action disabled-form-item" : "play-action"}
            >
              play_circle_filled_white_outlined_icon
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          variant="body1"
          sx={{
            cursor: row.original.blocked ? "not-allowed" : "pointer",
            lineHeight: 0,
            display: !filtered ? "" : "none",
            color: row.original.blocked ? "green" : "red",
            opacity: 0.7,
          }}
        >
          <Tooltip
            title={row.original.blocked ? "Blocked Fixture " : "Stop Feed Fixture"}
            placement="top"
          >
            <Icon
              isdisabled={row.original.blocked ? "true" : "false"}
              onClick={
                row.original.blocked
                  ? null
                  : (e) => handleApplyAction(e, id, row, filtered, "regular")
              }
              className={row.original.blocked ? "play-action disabled-form-item" : "stop-action"}
            >
              {row.original.blocked
                ? "play_circle_filled_white_outlined_icon"
                : "stop_circle_outlined_icon"}
            </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props of the CreateTemplate
ActionCell.propTypes = {
  id: PropTypes.number,
  filtered: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  row: PropTypes.object,
  traderView: PropTypes.bool,
  handleApplyAction: PropTypes.func,
};

export default ActionCell;
